export function getMissingDocs(docs) {
  const docVarieties = docs.map((d) => d.variety);
  let missing = [];

  if (!docs.length) {
    missing.push(0, 2, 1, 3);
  }

  if (docVarieties.includes(0)) {
    if (!docVarieties.includes(1) && !docVarieties.includes(3)) {
      [1, 3].forEach((n) => {
        if (!docVarieties.includes(n)) {
          missing.push(n);
        }
      });
    }
  }

  if (docVarieties.includes(1)) {
    [0].forEach((n) => {
      if (!docVarieties.includes(n)) {
        missing.push(n);
      }
    });
  }

  if (docVarieties.includes(3)) {
    [0].forEach((n) => {
      if (!docVarieties.includes(n)) {
        missing.push(n);
      }
    });
  }

  return missing;
}

export const varieties = [
  { text: "General Liability", value: 0 },
  { text: "General Liability/Workman's Comp", value: 2 },
  { text: "Workman's Comp", value: 1 },
  { text: "State Exemption", value: 3 },
].map((m) => ({ ...m, key: m.value }));

export const varietyFormatted = varieties.reduce(
  (acc, cur) => ({
    ...acc,
    [cur.value]: cur.text,
  }),
  {}
);
